import {
    getTagTreesData,
    queryFormList,
    saveTagTreesData,
    moveTagTreesData,
    deleteTagTreesData,
    updateTagTreesData,
    updateFormStatus,
    deleteForms,
    copyForms,
    setDefaultForm,
    cancelDefaultForm,
    isSetDefaultForm,
} from "@/views/zhiji/js/services/service.js";
import i18n from "@/i18n";

export default {
    state: {
        treeData: [],
        tableDatas: [],
        total: 0,
        querySetting: {
            page: 1
        }
    },
    mutations: {
        tagTreesDataChange(state, treeData) {
            let newDatas = {
                label: i18n.t("zhiji.common.allClassify"),
                id: "-1",
                smallLabel: "",
                children: treeData
            };
            state.treeData = newDatas;
        },
        updateFormList(state, tableData) {
            state.tableDatas.splice(0, state.tableDatas.length, ...tableData.dataset);
            state.total = tableData.total;
        },
        updateFormListSetting(state, setting = {}) {
            state.querySetting = Object.assign({}, state.querySetting, setting);
        },
        initFormQuerySet(state) {
            state.querySetting = {};
        }
    },
    actions: {
        getTagTreesData(context) {
            getTagTreesData().then(function(dataList) {
                context.commit("tagTreesDataChange", dataList);
            });
        },
        addTagTrees(context, treeData) {
            saveTagTreesData(treeData).then(result => {
                result === "success" ? context.dispatch("getTagTreesData") : "";
            });
        },
        updateTagTrees(context, treeData) {
            updateTagTreesData(treeData).then(result => {
                result === "success" ? context.dispatch("getTagTreesData") : "";
            });
        },
        deleteTagTrees(context, treeData) {
            deleteTagTreesData(treeData).then(result => {
                result === "success" ? context.dispatch("getTagTreesData") : "";
            });
        },
        moveTagTrees(context, treeData) {
            moveTagTreesData(treeData).then(result => {
                result === "success" ? context.dispatch("getTagTreesData") : "";
            });
        },
        queryFormList(context, param) {
            param && context.commit("updateFormListSetting", param);
            let querySetting = context.state.querySetting;

            queryFormList(querySetting).then(tableData => {
                context.commit("updateFormList", tableData);
            });
        },
        updateFormStatus(context, param) {
            updateFormStatus(param).then(result => {
                result.status
                    ? context.dispatch("queryFormList")
                    : context.dispatch("showModal", {
                          type: "MessageModal",
                          data: {
                              type: "tip",
                              message: `${i18n.t("zhiji.form.stopFormTip")}
                              <div style="margin-top: 16px">
                                <p>${i18n.t("zhiji.form.usingAnswerId")}:</p>
                                <p>${result.answers.map(item => JSON.stringify(item)).join("<br/>")}</p>
                              </div>`
                          }
                      });
            });
        },
        deleteForms(context, param) {
            deleteForms(param).then(result => {
                result.status
                    ? context.dispatch("queryFormList")
                    : context.dispatch("showModal", {
                          type: "MessageModal",
                          data: {
                              type: "tip",
                              message: `${i18n.t("zhiji.form.stopFormTip")}
                        <div style="margin-top: 16px">
                          <p>${i18n.t("zhiji.form.usingAnswerId")}:</p>
                          <p>${result.answers.map(item => JSON.stringify(item)).join("<br/>")}</p>
                        </div>`
                          }
                      });
            });
        },
        copyForms(context, param) {
            copyForms(param).then(result => {
                result === "success" ? context.dispatch("queryFormList") : "";
            });
        },
        setDefaultForm(context, param) {
            const { formId, lang } = param;
            isSetDefaultForm({ lang: lang || 'other' }).then(result => {
                const { exist } = result;
                if (exist) {
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: i18n.t("zhiji.form.defaultFormTip"),
                            cancel: () => {},
                            confirm: () => {
                                setDefaultForm({ formId }).then(res => {
                                    res === "success" ? context.dispatch("queryFormList") : "";
                                })
                            }
                        }
                    })
                } else {
                    setDefaultForm(param).then(res => {
                        res === "success" ? context.dispatch("queryFormList") : "";
                    })
                }
            })
        },
        cancelDefaultForm(context, param) {
            cancelDefaultForm(param).then(result => {
                result === "success" ? context.dispatch("queryFormList") : "";
            })
        },
    }
};
